// extracted by mini-css-extract-plugin
export default {"link":"PrevLink_link__L-u6D"};